import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routes } from './index';
import PrivateRoute from '../components/PrivateRoute';
import Loader from '../components/Loader';
import { useAuth0 } from '../react-auth0-spa';

const Routes = ({ setSelectedLink, selectedLink, permissionsSet }) => {
  const { isAuthenticated, loginWithRedirect, loading } = useAuth0();

  useEffect(() => {
    if (loading && !isAuthenticated && !permissionsSet) {
      loginWithRedirect({});
    }
    // eslint-disable-next-line
  }, [loading])

  return permissionsSet ? (
    <Switch>
      {routes.map(({ component, path, permissions }, index) => (
        <PrivateRoute
          key={index}
          exact
          component={component}
          path={path}
          setSelectedLink={setSelectedLink}
          selectedLink={selectedLink}
          permissions={permissions}
        />
      ))}
      <Route exact path='/*'>
        <Redirect to='/' />
      </Route>
    </Switch>
  ) : (
    <Loader />
  );
};

Routes.propTypes = {
  setSelectedLink: PropTypes.func.isRequired,
  selectedLink: PropTypes.string.isRequired,
  permissionsSet: PropTypes.bool.isRequired,
};

export default Routes;
